import React, { FC } from 'react';
import TopStripedBanner from '@app/common/PageHeader/TopStripedBanner';
import HeaderBar from '@app/common/PageHeader/HeaderBar';
import HeaderNav from '@app/common/PageHeader/HeaderNav';
import { StickyHeader } from '@base/lib/StickyHeader';
import { useStoreState, observer } from 'base/store';
import type { ILogoType } from '@app/common/PageHeader/HeaderLogo';
import styles from './index.module.less';

export type IPageHeaderProps = {
    headerProps?: {
        showNav?: boolean;
        showTopStripedBanner?: boolean;
        showHeaderBar?: boolean;
        renderHeaderBar?: React.ReactNode;
        fixedShowBar?: React.ReactNode;
        onlyShowLogo?: boolean;
        sticky?: boolean;
        logoType?: ILogoType;
        className?: string;
    }
}

const HeaderMain: React.FC<IPageHeaderProps['headerProps']> = props => {
    const {
        showNav = true,
        showHeaderBar = true,
        renderHeaderBar,
        fixedShowBar,
        onlyShowLogo,
        className,
        logoType
    } = props || {};

    return (
        <div className={className}>
            {showHeaderBar && (
                <>
                    {renderHeaderBar ? (
                        <>{renderHeaderBar}</>
                    ) : (
                        <HeaderBar logoType={logoType} onlyShowLogo={onlyShowLogo}/>
                    )}
                </>
            )}

            {showNav && <HeaderNav/>}

            {!!fixedShowBar && (
                <div className={styles['fixedShow']}>
                    {fixedShowBar}
                </div>
            )}
        </div>
    )
}

const PageHeader: FC<IPageHeaderProps> = props => {
    const { headerProps } = props;

    const { showTopStripedBanner = true, sticky = true, } = headerProps || {};

    const { visible: miniCartVisible } = useStoreState('miniCartStore');

    return (
        <>
            {showTopStripedBanner && <TopStripedBanner/>}

            {sticky
                ? (
                    <StickyHeader id="js-sticky-header" forceShow={miniCartVisible} hideWhenDown>
                        <HeaderMain {...headerProps}/>
                    </StickyHeader>
                )
                : <HeaderMain {...headerProps}/>
            }
        </>
    );
}

export default observer(PageHeader);
